import { render, staticRenderFns } from "./chevron.vue?vue&type=template&id=1bf35250&"
import script from "./chevron.vue?vue&type=script&lang=js&"
export * from "./chevron.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports